"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStreamsEvm = void 0;
var api_utils_1 = require("@moralisweb3/api-utils");
var evm_utils_1 = require("@moralisweb3/evm-utils");
var name = 'GetStreams';
exports.getStreamsEvm = (0, api_utils_1.createPaginatedEndpointFactory)(function () {
    return (0, api_utils_1.createPaginatedEndpoint)({
        name: name,
        getUrl: function () { return "/streams/evm"; },
        apiToResult: function (data) {
            var _a;
            return ((_a = data.result) !== null && _a !== void 0 ? _a : []).map(function (stream) { return (__assign(__assign({}, stream), { chains: stream.chainIds.map(function (chainId) { return evm_utils_1.EvmChain.create(chainId); }) })); });
        },
        resultToJson: function (data) {
            return data.map(function (stream) { return (__assign(__assign({}, stream), { chainIds: stream.chains.map(function (chain) { return chain.format(); }) })); });
        },
        parseParams: function (params) { return params; },
    });
});
